import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

class ProductInventory extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateInventory);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateInventory);
  }

  /**
   * Updates the inventory.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateInventory = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.detail.data.productId !== this.dataset.productId) {
      // Another product on the page changed variant; this badge is not the one to update.
      return;
    }

    // The response was rendered for the newly selected option values, so its badge already reflects
    // the selected variant's own inventory rather than the product's first or total stock.
    // Read it from this block's own section — a full-page response can carry the badge of another
    // product (a featured product section, for instance) ahead of ours in document order.
    const sectionId = this.closest('.shopify-section')?.id;
    const scope = (sectionId && event.detail.data.html.getElementById(sectionId)) || event.detail.data.html;
    const newInventory = scope.querySelector('product-inventory');

    if (!newInventory) return;

    morph(this, newInventory, { childrenOnly: true });
  };
}

if (!customElements.get('product-inventory')) {
  customElements.define('product-inventory', ProductInventory);
}
